<div class="container">
  <div class="row">
    <div class="col-sm-9 col-md-7 col-lg-5 mx-auto">
      <div class="card card-signin my-5">
        <div class="card-body">
          <h5 class="card-title text-center">{{'reset-password.title' | translate}}</h5>
          <form (ngSubmit)="onResetPassword(f)" #f="ngForm">
            <div class="form-group">
              <label for="code">{{'reset-password.recovery-code' | translate}}</label>
              <input type="text" id="code" name="code" ngModel class="form-control">
            </div>
            <div class="form-group">
              <label for="password">{{'reset-password.new-password' | translate}}</label>
              <input type="password" id="password" name="password" ngModel class="form-control">
            </div>
            <div class="form-group">
              <label for="confirm_password">{{'reset-password.confirm-password' | translate}}</label>
              <input type="password" id="confirm_password" name="confirm_password" ngModel class="form-control">
            </div>
            <div class="text-center">
              <button class="btn btn-primary btn-signin" type="submit">{{'reset-password.confirm' | translate}}</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
